// extracted by mini-css-extract-plugin
export default {"CrawledItem":"CrawledItem__mF9h+","card":"card__Q8k5f","image":"image__+ziyg","url":"url__35ey2"};